






















































































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Mall} from '@/views/claim/dataType/OrderProductOption';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import {ComponentItemsClaimDataType} from '@/views/claim/components/dataType/ComponentDataType';
import {GetClaimsOrderOptionsOrderOptionNoApply} from 'supporter';

@Component({
  components: {CompSelectBox, CompRadioButton}
})
export default class ComponentRefundExchangeAmount extends Vue {//D H
  @Prop({required: true})
  private pageName!: string;

  @Prop({default: ''})
  private type!: string;

  @Prop({required: true})
  private mall!: Mall;

  @Prop({required: false})
  private postPredict!: {};

  @Prop({default: false})
  private escrowOrder!: boolean;

  @Watch('postPredict')
  onPredictChange(){
    this.claimCalculation();
    if(this.pageName === 'ExchangePopupBefore' || this.pageName === 'ExchangePopupAfter' || this.pageName === 'ReturnPopup') {
      this.createExchangeInfo();
    } else {
      this.createRefundInfo();
    }
  }

  @Prop({default: false})
  private reSetData!: boolean ;

  @Prop({required: true})
  private objJson!: string;

  @Prop({required: true})
  private orderOptionsApply!: ComponentItemsClaimDataType;

  @Prop({default: false})
  private modifyClaim!: boolean ;

  @Prop({default: false})
  private accumulationUsed!: boolean ;

  @Prop({required: false})
  private claimOrderOptions!: GetClaimsOrderOptionsOrderOptionNoApply;

  @Prop({required: true})
  private refundTypeDivShow: boolean;

  @Prop({required: true})
  private zeroRefundShow: boolean;

  @Prop({required: true})
  private refundBankInfoTrShow: boolean;

  public claimTotal: number = 0;
  private accumulationPayAmt: number = 0;
  private mainPayAmt: number = 0;
  private exchangePayType: string = 'CASH';
  private exchangePayTypeDisabled: boolean = false;
  private tradeBankAccountInfo: string = '';
  private remitter: string = '';
  private refundTypes: {value: string; name: string}[] = [];
  private get refundTypeList() {
    return this.refundTypes;
  }
  private refundTypeMap: Map<string, string> = new Map();
  private refundBankValue: string = '';
  private refundBankAccount: string = '';
  private refundBankDepositorName: string = '';
  private refundInfoClaimRefundBank: string = '-';
  private totalExchangeAmt: number = 0;
  private refundBankList: any = '';
  private refundTypeValue: string = 'ACCOUNT';
  private initPayTypeMap() {
    this.refundTypeMap.set('CANCEL_DEPOSIT',this.$t('CLAIM_CANCELPOPUP_CANCEL_DEPOSIT').toString());
    this.refundTypeMap.set('PAYCO',this.$t('CLAIM_CANCELPOPUP_PAYCO').toString());
    this.refundTypeMap.set('CASH',this.$t('CLAIM_CANCELPOPUP_CASH').toString());
    this.refundTypeMap.set('PAYPAL',this.$t('CLAIM_CANCELPOPUP_PAYPAL').toString());
    this.refundTypeMap.set('STRIPE',this.$t('CLAIM_CANCELPOPUP_STRIPE').toString());
    this.refundTypeMap.set('ZERO_REFUND',this.$t('CLAIM_CANCELPOPUP_ZERO').toString());
    this.refundTypeMap.set('KCP',this.$t('CLAIM_CANCELPOPUP_KCP_CREDIT').toString());
    this.refundTypeMap.set('CREDIT_CARD',this.$t('CLAIM_CANCELPOPUP_CREDIT_CARD').toString());
    this.refundTypeMap.set('VIRTUAL_ACCOUNT',this.$t('CLAIM_CANCELPOPUP_VIRTUAL_ACCOUNT').toString());
    this.refundTypeMap.set('REALTIME_ACCOUNT_TRANSFER', this.$t('CLAIM_CANCELPOPUP_REALTIME_ACCOUNT_TRANSFER').toString());
    this.refundTypeMap.set('ESCROW_VIRTUAL_ACCOUNT', this.$t('CLAIM_CANCELPOPUP_ESCROW_VIRTUAL_ACCOUNT').toString());
    this.refundTypeMap.set('ESCROW_REALTIME_ACCOUNT_TRANSFER', this.$t('CLAIM_CANCELPOPUP_ESCROW_REALTIME_ACCOUNT_TRANSFER').toString());
    this.refundTypeMap.set('LIIVMATE',this.$t('CLAIM_CANCELPOPUP_LIIVMATE').toString());
    this.refundTypeMap.set('ZERO_PAY',this.$t('CLAIM_CANCELPOPUP_ZERO_PAY').toString());
    this.refundTypeMap.set('MOBILE',this.$t('CLAIM_CANCELPOPUP_MOBILE').toString());
    this.refundTypeMap.set('SAMSUNG_PAY',this.$t('CLAIM_CANCELPOPUP_SAMSUNGPAY').toString());
    this.refundTypeMap.set('RENTAL',this.$t('CLAIM_CANCELPOPUP_RENTAL').toString());

    this.refundTypeMap.set('ACCUMULATION',this.$t('CLAIM_CANCELPOPUP_ACCUMULATION').toString());
    this.refundTypeMap.set('INICIS',this.$t('CLAIM_CANCELPOPUP_INICIS').toString());
    this.refundTypeMap.set('NAVER_EASY_PAY',this.$t('CLAIM_CANCELPOPUP_NAVEREASYPAY').toString());
    this.refundTypeMap.set('KAKAO_PAY',this.$t('CLAIM_CANCELPOPUP_KAKAOPAY').toString());
    this.refundTypeMap.set('NAVER_PAY',this.$t('CLAIM_CANCELPOPUP_NAVERPAY').toString());
    this.refundTypeMap.set('LG_U_PLUS',this.$t('CLAIM_CANCELPOPUP_LGUPLUS').toString());
    this.refundTypeMap.set('ACCOUNT',this.$t('CLAIM_CANCELPOPUP_ACCOUNT').toString());
    this.refundTypeMap.set('DUMMY',this.$t('CLAIM_CANCELPOPUP_DUMMY').toString());
    this.refundTypeMap.set('SK_PAY',this.$t('CLAIM_CANCELPOPUP_SKPAY').toString());
    this.refundTypeMap.set('TOSS_PAY',this.$t('CLAIM_CANCELPOPUP_TOSSPAY').toString());
    this.refundTypeMap.set('APPLE_PAY',this.$t('CLAIM_CANCELPOPUP_APPLEPAY').toString());
  }

  private get isRental() {
    return this.orderOptionsApply.payType === 'RENTAL';
  }

  private mounted() {
    this.initPayTypeMap();
    this.claimCalculation();
    if(this.pageName === 'ExchangePopupBefore' || this.pageName === 'ExchangePopupAfter' || this.pageName === 'ReturnPopup') {
      this.createExchangeInfo();
    }
    if(this.pageName === 'CancelPopup' || this.pageName === 'CancelAllPopup') {
      this.createRefundInfo(); // 환불
    }
  }
  private createExchangeInfo() {
    this.totalExchangeAmt = (this.postPredict as any).amounts.refund.order.totalExchangeAmt;
    this.exchangePayType = ((this.claimOrderOptions.availableAccumulationAmt) > (this.postPredict as any).amounts.adjustedAmounts.claimAmt) && this.accumulationUsed === true ? 'ACCUMULATION' : 'CASH'
    this.exchangePayTypeDisabled = !(((this.claimOrderOptions.availableAccumulationAmt) > (this.postPredict as any).amounts.adjustedAmounts.claimAmt) && this.accumulationUsed === true);
    this.createRefundInfo();
  }

  private createRefundInfo() {
    this.$api.getBanks({params: { countryCode: 'KR'}}).then(ret => {
      this.refundBankList = ret.data.filter(bank => bank.value !== 'ANONYMOUS');
      this.refundBankValue = this.refundBankList[0].value;
      this.refundBankAccount = '';
      this.refundBankDepositorName = '';
      let list: {value: string; name: string;}[] = [];
      if (this.orderOptionsApply.refundTypes) {
        this.orderOptionsApply.refundTypes.forEach((refundTypes: any, index: number) => {
            // 결제수단이 렌탈인 경우 렌탈환불만 가능.
            if (!this.isRental || (this.isRental && refundTypes.refundType === 'PG')) {
              list.push({
                value: refundTypes.refundType,
                name:
                  refundTypes.label +
                  (this.orderOptionsApply.payType != null &&
                  true &&
                  refundTypes.refundType !== 'ACCOUNT' &&
                  refundTypes.refundType !== 'ACCUMULATION'
                    ? '[' +
                      this.refundTypeMap.get(this.orderOptionsApply.payType) +
                      ']'
                    : ''),
              })
            }
          });
      }
      this.refundTypes = list;
      if (list.length > 0) {
        this.refundTypeValue = (this.$parent as any).getPayType(this.orderOptionsApply.payType);
      }
      if((this.claimTotal === this.accumulationPayAmt) && this.accumulationPayAmt !== 0) {
        this.refundTypes = [{
          name: '적립금환불',
          value: 'ACCUMULATION'
        }];
        this.refundTypeValue = 'ACCUMULATION'
      }
      if((this.pageName === 'CancelPopup' || this.pageName === 'ReturnPopup') && this.claimTotal < 0) {
        this.zeroRefundShow = true;
        this.refundTypeDivShow = false;
        this.refundTypeValue = 'ZERO_REFUND';
      }
      if(this.pageName === 'CancelAllPopup' && this.type === 'before') {
        this.refundTypeValue = 'ZERO_REFUND';
      }
      this.displayBankInfo('mounted');
    });

  }
  private refundBankEditShow: boolean = false;
  private refundBankShow: boolean = false;
  private displayBankInfo(method: string) {
    if(this.claimOrderOptions && this.claimOrderOptions.additionalPayBankAccounts) {
      this.tradeBankAccountInfo = this.claimOrderOptions.additionalPayBankAccounts[0]?.bank.bank + '|' + this.claimOrderOptions.additionalPayBankAccounts[0].bankAccount + '|' + this.claimOrderOptions.additionalPayBankAccounts[0].bankDepositorName
    }
    let isVisibleBankEditor = false;

    switch (this.refundTypeValue) {
      case 'CASH':
      case 'ACCOUNT':
      case 'ZERO_REFUND':
        isVisibleBankEditor = true;
        break;
      case 'PG':
        if(this.orderOptionsApply.payType === 'VIRTUAL_ACCOUNT' || this.orderOptionsApply.payType === 'ESCROW_VIRTUAL_ACCOUNT') {
          isVisibleBankEditor = true;
        }
        break;
    }
    if (isVisibleBankEditor) {
      this.refundBankShow = false;
      this.refundBankEditShow = true;
    } else {
      this.refundBankAccount = '';
      this.refundBankDepositorName = '';
      this.refundBankValue = this.refundBankList[0].value;
      this.refundBankShow = true;
      this.refundBankEditShow = false;
    }
    if (this.escrowOrder) {
      if(this.refundTypeValue === 'ACCOUNT') {
        (this.$parent.$refs.componentItemsClaim as any).claimReasonTypeDisabled = false;
        (this.$parent.$refs.componentProductDetails as any).chargeDeliveryAmtDisabled = false;
      } else if(this.refundTypeValue === 'PG' && method === 'refundType') {
        if(confirm(this.$t('CLAIM_RETURNPOPUP_CONFIRM2').toString()) === false) {
          this.$nextTick(() => {
            this.refundTypeValue = 'ACCOUNT';
            this.refundBankShow = false;
            this.refundBankEditShow = true;
          });
        } else {
          this.$nextTick(() => {
            (this.$parent.$refs.componentItemsClaim as any).claimReasonType = 'OTHERS_SELLER';
            (this.$parent.$refs.componentItemsClaim as any).claimReasonTypeDisabled = true;
            (this.$parent.$refs.componentItemsClaim as any).responsibleObjectTypeValue = 'SELLER';
            (this.$parent.$refs.componentProductDetails as any).chargeDeliveryAmt = 'true';
            (this.$parent.$refs.componentProductDetails as any).chargeDeliveryAmtDivFlg = 'true';
            (this.$parent.$refs.componentProductDetails as any).chargeDeliveryAmtDisabled = true;
            (this.$parent.$refs.componentReturnShippingFee as any).textDecoration = 'line-through';
            (this.$parent.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustAmtDisabled = true;
            (this.$parent.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustAmt = 0;
            (this.$parent.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustReason = '';
            (this.$parent.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustReasonDisabled = true;
            this.$emit('setData');
          });
        }
      }
    }
  }
  private claimCalculation() {
    if(this.pageName === 'CancelPopup' || this.pageName==='CancelAllPopup' || this.pageName === 'ReturnPopup') {
      this.claimTotal = (this.postPredict as any).amounts.adjustedAmounts.claimAmt * -1
    } else if(this.pageName === 'ExchangePopupBefore' || this.pageName === 'ExchangePopupAfter') {
      this.claimTotal = (this.postPredict as any).amounts.adjustedAmounts.claimAmt
    }
    this.accumulationPayAmt = (this.postPredict as any).amounts.adjustedAmounts.accumulationPayAmt
    this.mainPayAmt = (this.postPredict as any).amounts.adjustedAmounts.mainPayAmt
  }
}
